import { Component } from '@angular/core';

@Component({
  selector: 'sh-page-layout',
  template: `
    <ng-content select="[header], sh-header"> </ng-content>
    <div class="page-content">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .page-content {
        padding: 0.75rem 0.75rem 0;
      }
    `,
  ],
})
export class PageLayoutComponent {}
